import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import axios from "axios";
import { toast } from "react-toastify";
import { API_URL, TOKEN } from "../../../variables/constants";

const AddEntiteConstat = ({
  show,
  handleClose,
  editMode,
  selectedEntite,
  entites,
  onAdd,
  onUpdate,
}) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    nom: "",
    adresse: "",
    telephone1: "",
    telephone2: "",
  });

  useEffect(() => {
    if (editMode && selectedEntite) {
      setFormData({
        nom: selectedEntite.nom ?? "",
        adresse: selectedEntite.adresse ?? "",
        telephone1: selectedEntite.telephone1 ?? "",
        telephone2: selectedEntite.telephone2 ?? "",
      });
    } else {
      setFormData({ nom: "", adresse: "", telephone1: "", telephone2: "" });
    }
  }, [editMode, selectedEntite]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      entiteConstatId: editMode ? selectedEntite.entiteConstatId : undefined,
      nom: formData.nom.trim(),
      adresse: formData.adresse.trim(),
      telephone1: formData.telephone1.trim(),
      telephone2: formData.telephone2.trim(),
    };

    const isDuplicate = !editMode && entites?.some(
      (e) => e.nom.trim().toLowerCase() === payload.nom.toLowerCase()
    );

    if (isDuplicate) {
      toast.error("Cette entité existe déjà.");
      setLoading(false);
      return;
    }

    try {
      const res = editMode
        ? await axios.put(`${API_URL}/api/entite-constat`, payload, {
            headers: { Authorization: `Bearer ${TOKEN}` },
          })
        : await axios.post(`${API_URL}/api/entite-constat`, payload, {
            headers: { Authorization: `Bearer ${TOKEN}` },
          });

      toast.success(editMode ? "Entité modifiée avec succès" : "Entité ajoutée avec succès");

      if (editMode) onUpdate && onUpdate(res.data);
      else onAdd && onAdd(res.data);

      handleClose();
    } catch (err) {
      console.error(err);
      toast.error("Erreur lors de l'enregistrement de l'entité");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={show}
      onCancel={handleClose}
      onOk={onSubmit}
      confirmLoading={loading}
      title={editMode ? "Modifier l'entité" : "Ajouter une entité"}
      okText="Enregistrer"
      cancelText="Annuler"
    >
      <form className="row g-3">
        <div className="col-12">
          <label htmlFor="nom">Nom</label>
          <input
            type="text"
            id="nom"
            name="nom"
            className="form-control"
            value={formData.nom}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-12">
          <label htmlFor="adresse">Adresse</label>
          <input
            type="text"
            id="adresse"
            name="adresse"
            className="form-control"
            value={formData.adresse}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-md-6">
          <label htmlFor="telephone1">Téléphone 1</label>
          <input
            type="text"
            id="telephone1"
            name="telephone1"
            className="form-control"
            value={formData.telephone1}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-6">
          <label htmlFor="telephone2">Téléphone 2</label>
          <input
            type="text"
            id="telephone2"
            name="telephone2"
            className="form-control"
            value={formData.telephone2}
            onChange={handleChange}
          />
        </div>
      </form>
    </Modal>
  );
};

export default AddEntiteConstat;
